function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import Radio from './radio.js';
import RadioButton from './button.js';
export default {
  name: buildComponentName('RadioGroup'),
  provide: function provide() {
    return {
      radioGroupRoot: this
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-radio-group'
    },
    type: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['default', 'button'].indexOf(val) > -1;
      }
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['large', 'default', 'small', ''].indexOf(val) > -1;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerValue: ''
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          size = this.size;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size), size), _ref;
    },
    normalizeOptions: function normalizeOptions() {
      var _this$options = this.options,
          options = _this$options === void 0 ? [] : _this$options;
      return options.map(function (v) {
        var ret = v;

        if (typeof v === 'string') {
          ret = {
            label: v,
            value: v
          };
        }

        return ret;
      });
    }
  },
  watch: {
    value: function value(nVal) {
      this.innerValue = nVal;
    }
  },
  created: function created() {
    this.innerValue = this.value;
  },
  methods: {
    onGroupChange: function onGroupChange(optVal) {
      // fix http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/309
      // 理论上应该全面放开，但是原作者认为有场景需要限制，暂时先放开0
      if (!optVal && optVal !== 0) {
        return;
      }

      var innerValue = this.innerValue;

      if (innerValue !== optVal) {
        this.$emit('change', optVal, innerValue);
        this.$emit('input', optVal);
        this.innerValue = optVal;
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        type = this.type,
        normalizeOptions = this.normalizeOptions;
    var Cmp = type === 'button' ? RadioButton : Radio;
    var radios = normalizeOptions.length > 0 ? normalizeOptions.map(function (v) {
      return h(Cmp, {
        "attrs": {
          "label": v.label,
          "value": v.value,
          "disabled": v.disabled
        }
      });
    }) : this.$slots.default;
    return h("div", {
      "class": classes
    }, [radios]);
  }
};